import { get, post, put, destroy } from './config';

const MapsData = {
    sendRoute: (data) =>
        post('/v1/routes', data),
    getRoute: (cityFrom, cityTo) =>
        get(`/v1/routes?fromCityId=${cityFrom}&toCityId=${cityTo}`),
    getRouteByAddressId: (fromAddressId, toAddressId) =>
        get(`/v1/routes/by-address?fromAddressId=${fromAddressId}&toAddressId=${toAddressId}`),
    deleteRoute: (routeId) =>
        destroy(`/v1/routes/${routeId}`),
    editRoute: (routeId, data) =>
        put(`/v1/routes/${routeId}`, data)
}

export default MapsData;